// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingCategoriesPage_root__83gHb","section":"UnderwritingCategoriesPage_section__v-hr8","headerButton":"UnderwritingCategoriesPage_headerButton__2uCrb"};